// Waveform Visualisation Module
//
// Draws a live audio waveform horizontaly

// TODO:
// [] Make the waveform height exponential and constrained to the canvas height
// [] Add an option for a gain on waveform height

import { remap } from '../utils.js';

export { setup, draw };

let offscreen;
let ctx;
let width;
let height;

// Module-global variables pulled out of their functions for better memory managment
let i; let x; let y; // Used in draw()

const options = {
  background: 'black',
  color: '#ff8800',        // Waveform color
  adaptPixelRatio: true,
  waveformLineWidth: 1,
};

function setup({ cellWidth, cellHeight, devicePixelRatio }) {
  // Save these dimensions as module-scoped variables
  width = cellWidth * devicePixelRatio;
  height = cellHeight * devicePixelRatio;
  if (options.adaptPixelRatio) {
    width = cellWidth * devicePixelRatio;
    height = cellHeight * devicePixelRatio;
    options.waveformLineWidth *= devicePixelRatio;
  } else {
    width = cellWidth;
    height = cellHeight;
  }

  // Create an offscreen graphics buffer to draw in
  offscreen = new OffscreenCanvas(width, height);
  ctx = offscreen.getContext('2d');

  // Fill in the background with a solid color
  ctx.fillStyle = options.background;
  ctx.clearRect(0, 0, width, height);
}

function draw(waveformData) {
  if (waveformData) {
    // Erase the graphics buffer with background color
    ctx.clearRect(0, 0, width, height);

    // Set waveform style
    ctx.strokeStyle = options.color;
    ctx.lineWidth = options.waveformLineWidth;

    // Draw waveform
    ctx.beginPath();
    for (i = 0; i < waveformData.length; i++) {
      x = remap(i, 0, waveformData.length, 0, width);
      y = remap(waveformData[i] * 8, -1, 1, 0, height); // FIXME: this * 8 is hacky, dig in...
      ctx.lineTo(x, y);
    }
    ctx.stroke();
    ctx.closePath();
  }

  return offscreen.transferToImageBitmap();
}
